import { useEffect } from 'react';
import { jwtDecode as jwt_decode } from 'jwt-decode';
import { useNavigate } from 'react-router-dom';

function ProtectedRoutes(props) {
  const { Component } = props;
  const navigate = useNavigate();

  const isTokenExpired = (authToken) => {
    try {
      const decoded = jwt_decode(authToken); 
      const currentTime = Date.now() / 1000; 
      return decoded.exp < currentTime; 
    } catch (error) {
      console.error('Error decoding token:', error);
      return true;
    }
  };

  useEffect(() => {
    let authToken = sessionStorage.getItem('token');
    if (authToken) {
      if (isTokenExpired(authToken)) {
        sessionStorage.removeItem('token');
        sessionStorage.removeItem('emailID');
        sessionStorage.removeItem('role');
        sessionStorage.removeItem('userId');
        sessionStorage.removeItem('userName');
        alert('Your session has expired. Please log in again.');
        navigate('/');
      }
      
    }else{
      navigate('/');
    }
  })
  return (
    <div>
      <Component />
    </div>
  )
}

export default ProtectedRoutes
